import clsx from "clsx";

import { COLOR_BY_STATUS } from "constants/base";
import { formatNumber } from "helpers/formatNumber";
import { useColorScheme } from "hooks/useColorScheme";
import styles from "./style.module.scss";

interface IProps {
  selectedFR?: any;
}

export default function FrStatusForCarrier({ selectedFR }: Readonly<IProps>) {
  const { currentIsDark } = useColorScheme();

  const fuelAdvance =
    selectedFR?.fuelAdvanceAmount > 0
      ? formatNumber(selectedFR?.fuelAdvanceAmount / 100, 2)
      : "$0.00";
  const fuelAdvanceFee =
    selectedFR?.fuelAdvanceAmount && selectedFR?.fuelAdvanceFee > 0
      ? formatNumber(selectedFR?.fuelAdvanceFee / 100, 2)
      : "$0.00";
  const debtorAdvance =
    selectedFR?.debtorAdvance > 0 ? formatNumber(selectedFR?.debtorAdvance / 100, 2) : "$0.00";

  return (
    <div className={clsx(styles.cardBoxContainer, "!mt-0 !gap-4")}>
      <span className="desktop:hidden">Collapse Status</span>
      <div
        className={clsx(
          styles.cardBoxWrapper,
          !currentIsDark && "drop-shadow-[0_2px_4.5px_#9E9E9E33]"
        )}>
        <div className={styles.cardTitle}>
          <span>Total Pay</span>
          <span
            className={clsx(
              "pl-4 font-bold !bg-transparent !inline-block !border-none",
              COLOR_BY_STATUS[selectedFR?.status]
            )}>
            {selectedFR?.status}
          </span>
        </div>
        <ul
          className={clsx(styles.cardBody, "desktop:!grid desktop:!grid-cols-7 desktop:!gap-x-2")}>
          <li>
            <span className="text-xs desktop:text-sm">Invoice Amount</span>
            <span className="font-bold text-primary">
              {selectedFR?.amount ? formatNumber(selectedFR?.amount, 2) : "$0.00"}
            </span>
          </li>
          <li>
            <span className="text-xs desktop:text-sm">Debtor Advance</span>
            <span className="font-bold text-text">{debtorAdvance}</span>
          </li>
          <li>
            <span className="text-xs desktop:text-sm">Discount Rate</span>
            <span className="font-bold text-text">
              {selectedFR?.discountRate ? `${selectedFR?.discountRate}%` : "$0.00"}
            </span>
          </li>
          <li>
            <span className="text-xs desktop:text-sm">Discount Fee</span>
            <span className="font-bold text-text">
              {selectedFR?.amount
                ? formatNumber((selectedFR?.amount * selectedFR?.discountRate) / 100, 2)
                : "$0.00"}
            </span>
          </li>
          <li className="!border-none">
            <span className="text-xs desktop:text-sm">Fuel Advance</span>
            <span className="font-bold text-text">{fuelAdvance}</span>
          </li>
          <li className="!border-none">
            <span className="text-xs desktop:text-sm">Fuel Advance Fee</span>
            <span className="font-bold text-text">{fuelAdvanceFee}</span>
          </li>
          <li className="!border-none">
            <span className="text-xs desktop:text-sm mobile:text-time">Total Pay</span>
            <span className="font-bold text-success">
              {selectedFR?.amount
                ? formatNumber(
                    selectedFR?.amount -
                      (selectedFR?.fuelAdvanceAmount ? selectedFR?.fuelAdvanceFee / 100 : 0) -
                      (selectedFR?.amount * selectedFR?.discountRate) / 100,
                    2
                  )
                : "$0.00"}
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
}
